// extracted by mini-css-extract-plugin
export default {"modal":"IG-z","error":"JG-z","disabled":"KG-z","fields":"LG-z","errorMsg":"MG-z","footer":"NG-z","formContentWrapper":"OG-z","productImage":"PG-z","overlay":"QG-z"};